export const EXPENSES_TYPES = {
  1: 'pre GP',
  2: 'post GP'
}

export const PRE_GP = 1

export const POST_GP = 2
